import React from "react";

// SVG progress ring
export default function MacroRing({ value = 0, goal = 1, color = "#FF3B30", size = 120, stroke = 10, label, unit = "g" }) {
  const pct = Math.min(1, goal > 0 ? value / goal : 0);
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ * (1 - pct);
  return (
    <div className="flex flex-col items-center" data-testid={`macro-ring-${(label || "").toLowerCase()}`}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="-mt-[calc(50%+8px)] flex flex-col items-center pointer-events-none" style={{ height: 0 }}>
        <div className="font-mono text-2xl font-bold text-white">{Math.round(value)}</div>
        <div className="text-[10px] uppercase tracking-widest text-[#737373]">/ {Math.round(goal)}{unit}</div>
      </div>
      {label && <div className="mt-6 text-xs uppercase tracking-[0.2em] font-semibold" style={{ color }}>{label}</div>}
    </div>
  );
}
